module.exports = __webpack_public_path__ + "img/exit.0d110ab1.svg";